import type { MonetaryAmountFragment } from 'bundles/payments-common/api/__generated__/QueryCourseraTierProductConfigurations';
import type { ProductPrices } from 'bundles/payments-common/hooks/useGetProductPrices';

/**
 *  Converts a ProductPrices object to a MonetaryAmount object
 *
 * @param productPrice
 * @returns MonetaryAmount
 */

export const productPriceToMonetaryAmount = (productPrice?: ProductPrices) => {
  return {
    value: String(productPrice?.amount),
    currencyCode: productPrice?.currencyCode as MonetaryAmountFragment['currencyCode'],
  };
};
